import type { ReactElement } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { AUTH_KEY } from "@/hooks/useAuth";
import { authApi } from "@/lib/authApi";
import { CandleVoiceToggle } from "./CandleVoiceToggle";
import { NotificationBell } from "./NotificationBell";
import { Nav } from "./Nav";

export function AppHeader(): ReactElement {
  return (
    <header className="border-b border-line bg-surface-1">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3">
        <div className="flex items-center gap-6">
          <Brand />
          <Nav />
        </div>
        <div className="flex items-center gap-3">
          <CandleVoiceToggle />
          <NotificationBell />
          <LogoutButton />
        </div>
      </div>
    </header>
  );
}

function Brand(): ReactElement {
  return (
    <div className="flex items-center gap-2">
      <div
        aria-hidden
        className="flex h-7 w-7 items-center justify-center rounded-ctl bg-accent-bg"
      >
        <i className="ti ti-chart-line text-base text-accent" />
      </div>
      <div className="text-sm font-medium">NSS</div>
    </div>
  );
}

function LogoutButton(): ReactElement {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const logoutMut = useMutation({
    mutationFn: () => authApi.logout(),
    onSuccess: () => {
      qc.removeQueries({ queryKey: AUTH_KEY });
      void navigate("/login", { replace: true });
    },
  });
  return (
    <button
      type="button"
      className="btn btn-secondary text-sm"
      onClick={() => {
        logoutMut.mutate();
      }}
      disabled={logoutMut.isPending}
    >
      <i className="ti ti-logout text-base" />
      Sign out
    </button>
  );
}
